import React, { PropsWithChildren } from 'react'
import QuotesCarouselBase, { IQuotesCarousel } from '../../components/QuotesCarousel/QuotesCarousel'

export type QuotesCarouselProps = {
  quote_carousel_item: QuotesCarouselDataProps[]
}

export type QuotesCarouselDataProps = {
  id: number
  description: string
  brand_image: {
    filename: string
  }
  large_image: {
    filename: string
  }
}

const QuoteCarousel: React.FC<PropsWithChildren<{slice:QuotesCarouselProps}>> = ({ slice }) => {
  const { quote_carousel_item } = slice

  const quoteCarouselData:IQuotesCarousel[]=[]

  quote_carousel_item.map((item:QuotesCarouselDataProps,index:number)=>{
    quoteCarouselData.push({
      id: index,
      description:item.description,
      brand:item.brand_image.filename,
      picture:item.large_image.filename,
    })
  })

  return (
    <QuotesCarouselBase
      isPlaying={true}
      interval={5000}
      touchEnabled={true}
      dragEnabled={true}
      // @ts-ignore
      data={quoteCarouselData}
    />
  )
}

export default QuoteCarousel
